const NETWORK_FETCH_ERROR_MESSAGES = new Set([
  'Failed to fetch',
  'Load failed',
  'NetworkError when attempting to fetch resource.',
])

export const isNetworkFetchErrorMessage = (message: string): boolean =>
  NETWORK_FETCH_ERROR_MESSAGES.has(message)

export const isNetworkFetchError = (error: unknown): error is TypeError =>
  error instanceof TypeError
  && isNetworkFetchErrorMessage(error.message)
